module.exports = __webpack_public_path__ + "static/media/synth_fail.b04521a0.mp3";